var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 4.5H15.25V1.5C15.25 1.10218 15.092 0.720644 14.8107 0.43934C14.5294 0.158035 14.1478 0 13.75 0H1.75C1.35218 0 0.970644 0.158035 0.68934 0.43934C0.408035 0.720644 0.25 1.10218 0.25 1.5V13.5C0.25044 13.6411 0.290675 13.7792 0.366083 13.8985C0.441491 14.0177 0.549012 14.1133 0.676294 14.1742C0.803577 14.2351 0.945457 14.2589 1.08564 14.2428C1.22581 14.2266 1.3586 14.1713 1.46875 14.0831L4.75 11.4375V14.25C4.75 14.6478 4.90804 15.0294 5.18934 15.3107C5.47064 15.592 5.85218 15.75 6.25 15.75H15.0241L18.5312 18.5831C18.664 18.6905 18.8293 18.7493 19 18.75C19.1989 18.75 19.3897 18.671 19.5303 18.5303C19.671 18.3897 19.75 18.1989 19.75 18V6C19.75 5.60218 19.592 5.22064 19.3107 4.93934C19.0294 4.65804 18.6478 4.5 18.25 4.5ZM4.23906 9.91687L1.75 11.9297V1.5H13.75V9.75H4.71063C4.53897 9.75002 4.37252 9.80893 4.23906 9.91687ZM18.25 16.4297L15.7609 14.4169C15.6282 14.3095 15.4629 14.2507 15.2922 14.25H6.25V11.25H13.75C14.1478 11.25 14.5294 11.092 14.8107 10.8107C15.092 10.5294 15.25 10.1478 15.25 9.75V6H18.25V16.4297Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.001e184e3815a6a3be5eb912948e298b.svg";
export { ForwardRef as ReactComponent };